import {ESTADOSRESERVAS} from "../../Modulo_Motor_Reservas/Constantes";
import {ORIGENESDINERO} from "../../Constantes";

export const obtenerOrigenIngreso = (estado) => {

    switch (estado) {
        case ESTADOSRESERVAS[4] :
            return ORIGENESDINERO[2]

        case ESTADOSRESERVAS[0] :
            return ORIGENESDINERO[1]

        default :
            return ORIGENESDINERO[1]
    }

}